import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '@appShared/services/common.service';

@Injectable({ providedIn: 'root' })
export class SiteService {
  private _siteAdminApi = '/api/admin/site';

  constructor(
    private _http: HttpClient,
    private _commonService: CommonService
  ) {}

  toggleIsAdminOnlyMode(isAdminOnlyMode: boolean): Observable<boolean> {
    const url = `${this._siteAdminApi}/set-offline/${isAdminOnlyMode}`;
    const options = this._commonService.httpPostOptions();

    // return of(isAdminOnlyMode);
    return this._http.put<boolean>(url, null, options);
  }
}
